const postulacion = {
  preguntasObligatorias: {
    enabled: true,
  },
}
export default postulacion
